import $ from 'jquery';
import 'select2';

// try choices? select2 no updates since 2020
// https://github.com/Choices-js/Choices
const Search = $.fn.select2.amd.require('select2/selection/search');
const origResizeSearch = Search.prototype.resizeSearch;
const origUpdate = Search.prototype.update;

Search.prototype.resizeSearch = function () {
    origResizeSearch.call(this);
    var width = this.$selection.find('.select2-selection__rendered').width();
    this.$search.css('width', width);
};

Search.prototype.update = function (decorated, data) {
    origUpdate.call(this, decorated, data);
    if (data.length > 0) {
        const nouns = this.options.options.overrideNoun || [];
        let noun = data.length !== 1
            ? nouns[0] || 'Elemente'
            : nouns[1] || 'Element';
        this.$search.attr('placeholder', `${data.length} ${noun} ausgewählt`);
    }
};

$('select[multiple]:not(.no-select2)').each((_, elem) => {
    const $select = $(elem);
    const $first = $select.find('option[value=""]').first();
    const placeholderText = $first.text().trim();
    $first.remove();
    $select.select2({
        width: '100%',
        minimumResultsForSearch: 10,
        placeholder: placeholderText,
        closeOnSelect: false,
        overrideNoun: [
            $select.attr('data-noun-plural'),
            $select.attr('data-noun-singular'),
        ],
    });
});

$('select:not([multiple]):not(.no-select2)').each(function () {
    $(this).select2({
        width: '100%',
        minimumResultsForSearch: -1, // disable search box
    });

    //Set placeholder class for styling if the select value is empty. The default placeholder implementation by select2 removes the first option.
    setPlaceholderClass($(this));
    $(this).on('change', function () {
        setPlaceholderClass($(this));
    })
})

function setPlaceholderClass($select) {
    if ($select.val() === '') {
        $select.siblings('.select2').find('.select2-selection').addClass('select2-selection--placeholder');
    } else {
        $select.siblings('.select2').find('.select2-selection').removeClass('select2-selection--placeholder');
    }
}
